import { render, staticRenderFns } from "./v-table-searchable.vue?vue&type=template&id=6bbcd13e&"
import script from "./v-table-searchable.vue?vue&type=script&lang=js&"
export * from "./v-table-searchable.vue?vue&type=script&lang=js&"
import style0 from "./v-table-searchable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports